// src/store/usePNGSizeStore.js
import { create } from 'zustand';

const usePNGSizeStore = create((set) => ({
  userSelectedSizes: {},

  setSelectedSizeForCollection: (collection, size) => set((state) => ({
    userSelectedSizes: {
      ...state.userSelectedSizes,
      [collection]: size
    }
  })),

  getSelectedSizeForCollection: (collection) => (get) => {
    return get().userSelectedSizes[collection] || null;
  }
}));

export default usePNGSizeStore;
